import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4a8 8 0 110 16 8 8 0 010-16zm10 8c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zm-8.63-6.905a1.772 1.772 0 00-2.046.7l-4.008 6.012a1.91 1.91 0 00-.13 1.874c.29.606.897 1.031 1.606 1.035H9.4V17.154c.004.759.466 1.488 1.231 1.75a1.772 1.772 0 002.046-.699l4.008-6.012a1.91 1.91 0 00.13-1.874 1.796 1.796 0 00-1.606-1.035H14.6V6.847c-.004-.76-.466-1.49-1.231-1.752zm-4.257 7.62l3.489-5.231v3.8h2.285l-3.489 5.232v-3.8H9.114z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
